import React, { useEffect } from "react";
import { getWorkWiseAuthToken } from './helper'
import { workwiseServices } from "../Workw-Api/api";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { useDocument } from "../Pages/SpreadsheetContainer/documentInfoContex";
import Loader from "../components/SkeletonLoader/Loader";
import { getMergedCachedData } from "./documentCache";
import { isEffectivelyOffline } from "./helper";
import { isLocalGridRoute } from "./localGrids";

export const AuthenticateDocument = ({ setIsLoading, background = false }) => {


  const history = useHistory();
  const { id } = useParams();
  const { setDocumentInfo, setIsReadOnly, setDocID, isTemplateDocument } = useDocument();

  const handleAuhenticate = async () => {
    try {
      if (id) {
        setDocID(id);
      }
      setIsLoading(true);
      const searchParams = new URLSearchParams(document.location.search)
      const isReadOnlyQuery = searchParams.get("readOnly")
      if (isReadOnlyQuery == "true") {
        setIsReadOnly(true);
      }
      // Offline + local grid: there is no server counterpart, so skip the auth
      // API entirely instead of redirecting to /no-internet.
      if (isEffectivelyOffline() && isLocalGridRoute()) {
        setIsLoading(false);
        return;
      }
      if (!window.navigator.onLine) {
        // history.push('/no-internet');
        window.location.pathname = "/no-internet"

        return;
      }
      else {
        if (!!getWorkWiseAuthToken()) {
          const response = await workwiseServices.getDocumentById(id);
          if (response?.status == 200 && response.data?.data?.rightType !== 0 && response.data?.data) {
            setIsLoading(false);
            setDocumentInfo(response.data.data);
            if (response.data.data.rightType == 1) {
              setIsReadOnly(true);
            }
          }
          if (response.data?.data?.rightType == 0) {
            // history.push("/unauthorized")
            window.location.pathname = "/unauthorized"
          }
          // history.push("/unauthorized")
        }
        else {
          // history.push("/unauthorized")
          window.location.pathname = "/unauthorized"

        }
      }
    } catch (error) {
      console.log({ error })
      if (error.response?.data?.responseCode === 1008) {
        if (isTemplateDocument) {
          // For templates, 1008 is not a failure, set authenticated
          setIsLoading(false);
          return;
        } else {
          // navigate("/invalid-document")
          window.location.pathname = "/invalid-document"
        }
      }
      else {
        // history.push("/unauthorized")
        window.location.pathname = "/unauthorized"

      }
    }
    finally {
      setIsLoading(false);
    }
  }
  // Background mode = a cached document is already painting. Seed documentInfo
  // from the cache up front so the Header renders with real data instantly,
  // instead of staying empty until the background auth API resolves below.
  useEffect(() => {
    if (!background || !id) return;
    const cached = getMergedCachedData(id);
    if (cached?.documentInfo) {
      setDocumentInfo(cached.documentInfo);
    }
  }, [background, id]);

  useEffect(() => {
    if (isTemplateDocument === null) return;
    handleAuhenticate();
  }, [isTemplateDocument]);

  // In background mode (cached doc) auth still runs via the effect above, but we
  // render nothing so no loader is shown over the instantly-rendered cached data.
  return background ? null : <Loader />
}